<template>

    <van-form class="container" @submit="onSubmit" >
        <ul class="container zx-fill-ticket-info">

            <li class="header f-s-b">
                <div class="header-item">选择时间</div>
                <div class="header-item item-line left" ></div>
                <div class="header-item header-item-active theme-color-font">填写预约信息</div>
                <div class="header-item item-line"></div>
                <div class="header-item">完成</div>
            </li>

            <li class="body">
                <ul class="body-container">
                    <li class="body-header p-b-b ">
                        <div class="ticket-info item-row f-s-b">
                            <div class="left">
                                <i class="iconhebei iconmenpiao- theme-color-font icon-size"></i>
                                <span class="g-black-color g-b-500 ellipsis name">{{getTicketName}}</span>
                                <span class="g-yellow-color">{{getTicketPrice === 0 ? '免费': `¥${getTicketPrice}`}} </span>
                            </div>
                            <div class="right">
                                <!-- <span class="theme-color-font">入园须知></span> -->
                            </div>
                        </div>
                        <div class="ticket-use-time item-row f-s-b">
                            <i class="iconhebei iconshizhong g-yellow-color icon-size"></i>
                            <span class="samll-box g-black-color g-b-500">游玩时间</span>
                            <span class="samll-box">{{getTimeStr}}</span>
                            <!-- <span class="samll-box">09:00 - 12:00</span> -->
                        </div>
                    </li>
                    <li class="contacts-box-head f-s-b">
                        <span class="g-black-color g-b-500">联系人</span>
                        <!-- <span class="theme-color-font">+添加为常用联系人</span> -->
                    </li>
                    <li class="contacts-box p-b-b">
                        <!-- 团队的时候才填写 -->
                        <van-field
                            v-if="getTickerModeType === 2"
                            tag="li"
                            class="item-row f-s-b"
                            v-model.trim="companyName"
                            :border="false"
                            required
                            label="单位名称"
                            placeholder="联系单位名称"
                            name="contactsName"
                            :rules="[{ required: true, message: '请正确填写联系单位名称', validator: checkName }]"
                        />          
                        <van-field
                            tag="li"
                            class="item-row f-s-b"
                            v-model.trim="contactsInfo.name"
                            :border="false"
                            required
                            label="姓名"
                            placeholder="联系人姓名"
                            name="contactsName"
                            :rules="[{ required: true, message: '请正确填写联系人姓名', validator: checkName }]"
                        />          
                        <van-field
                            tag="li"
                            class="item-row f-s-b"
                            v-model.number="contactsInfo.phone"
                            type="tel"
                            maxlength="11"
                            :error="false"
                            :border="false"
                            required
                            label="手机号"
                            placeholder="联系人手机号"
                            name="contactsPhone"
                            :rules="[{ required: true, message: '请正确填写联系人手机号', validator: checkPhone }]"
                        />          
                        <van-field
                            tag="li"
                            class="item-row f-s-b"
                            v-model.trim="contactsInfo.id"
                            maxlength="18"
                            :error="false"
                            :border="false"
                            required
                            label="身份证"
                            placeholder="联系人身份证"
                            name="contactsPhone"
                            :rules="[{ required: true, message: '请正确填写联系人身份证', validator: checkId }]"
                        />          
                        <van-field
                            tag="li"
                            class="item-row f-s-b"
                            v-model.trim="contactsInfo.remark"
                            :error="false"
                            :border="false"
                            label="订单备注"
                            placeholder="请输入备注信息"
                        />          
                    </li>
                    <li class="tourist-btn hide-input">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="游客数量"
                            :rules="[{ required: false }]"
                        />
                        <div class="control-btn f-s-b">
                            <i v-touch:tap="changeUserListNumber(false)" class="iconhebei theme-color-font iconjianhao icon-size"></i>
                            <span class="number-box g-black-color g-b-500">{{userList.length}}</span>
                            <i v-touch:tap="changeUserListNumber(true)" class="iconhebei theme-color-font iconjiahao icon-size"></i>
                        </div>
                    </li>
                    <li class="contacts-box-head f-s-b">
                        <span class="g-black-color g-b-500">游客信息</span>
                    </li>
                    <li class="tourist-btn hide-input">
                        <van-field
                            class="item-row f-s-b"
                            :border="false"
                            required
                            label="证件类型"
                            :rules="[{ required: false }]"
                        />
                        <div class="control-btn f-s-b type-box">
                            <div class="btn-box" v-touch:tap="changeInfoType(true)">
                                <i class="iconhebei quan-size" :class="infoType ? 'iconxuanzhong theme-color-font':'iconweixuanzhong'" ></i>
                                <span>身份证</span>
                            </div>
                            <div class="btn-box" v-touch:tap="changeInfoType(false)">
                                <i class="iconhebei quan-size"  :class="!infoType ? 'iconxuanzhong theme-color-font':'iconweixuanzhong'"></i>
                                <span>护照</span>
                            </div>
                        </div>
                    </li>

                    <li 
                        v-for="(item, index) in userList" :key="index"
                        class="user-row"
                    >
                        <van-field
                            tag="li"
                            class="item-row f-s-b user-name"
                            v-model.trim="item.name"
                            :name="`name${index+1}`"
                            :border="false"
                            :label="`游客 ${index+1} :`"
                            placeholder="游客姓名"
                            :rules="[{ required: true, message: '请正确填写游客姓名', validator: checkName }]"
                        />
                        <van-field
                            @input="onInput(item)"
                            tag="li"
                            class="item-row f-s-b"
                            v-model.trim="item.id"
                            :name="`id${index+1}`"
                            :border="false"
                            label="证件号 :"
                            placeholder="证件号码"
                            :error-message="item.idNumberErrorTxt"
                            :rules="[{ required: true, message: '请正确输入证件号码', validator: checkId }]"
                        />
                        <i v-touch:tap="deleteItem(index)" class="iconhebei iconcuo icon-size" v-if="userList.length>1"></i>
                    </li>

                </ul>
            </li>

            <li class="foot f-s-b">
                <!-- <div class="left g-yellow-color">¥0</div> -->
                <div class="left g-yellow-color">{{getTicketPrice === 0 ? '免费': `¥${getTicketPrice}`}}</div>
                <!-- <div class="right f-c theme-color-bg">确认预约</div> -->
                <van-button class="right f-c theme-color-bg" block type="info" native-type="submit">
                    提交
                </van-button>
            </li>

        </ul>
    </van-form>

</template>

<script>
    import { 
        Field,
        Form, 
        Button,
    } from 'vant';

    import { 
        commitOrderTicketUrl,
    } from '@ticketUrl';

    export default {
        data() {
            return {
                phonePattern: /^1[3456789]\d{9}$/,
                idPattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                contactsInfo: {
                    name: '',
                    id: '',
                    phone: '',
                    remark: '',

                    // name: '测试',
                    // id: '510109198712211234',
                    // phone: '15928176933',
                    // remark: '测试备注',
                },
                userList:[
                    {
                        name: '',
                        id: '',
                        idNumberErrorTxt: ''
                        // name: '游客',
                        // id: '510109198712211234',
                        // idNumberErrorTxt: ''
                    },
                ],
                infoType:true,//    true 身份证 反之 护照
                companyName:'',//   单位名称
            }
        },
        methods: {
            changeUserListNumber(type = true){
                return ()=> {
                    if(type){
                        this.userList.push({name: '', id: '', idNumberErrorTxt: ''});
                    }else if(type === false && this.userList.length>1){
                        this.userList.splice(this.userList.length-1,1)
                    }
                }
            },
            changeInfoType(type){
                return ()=> { this.infoType = type; }
            },
            deleteItem(index){
                return ()=> { this.userList.splice(index,1) }
            },
            onSubmit(values) {

                if(values) {
                    // console.log('submit', values);

                    //  0：散客，1：团队
                    var type = this.getTickerModeType === 1 ? '0':'1' ,
                        visitorVOList = [];
                        this.userList.forEach(item=>{
                            visitorVOList.push({
                                name: item.name,
                                certificateType: this.infoType ? "0":"1",
                                certificateNo: item.id,
                            })
                        });

                    var data = {
                        orderUserVO: {
                            name: this.contactsInfo.name,
                            phone: this.contactsInfo.phone,
                            //   证件类型(0：身份证，1：护照，2：驾照）	
                            cardType: '0',// 证件类型
                            cardNo: this.contactsInfo.id,//   证件号
                            // accountId: this.getUserId,//    
                            accountId: this.getOpenId,//    
                            travelId: '',//     旅行社ID
                            travelName: this.companyName,//   单位名称
                        },
                        appPayTicketTypeList: [
                            {
                                ticketTypeId: this.getTicketId,
                                ticketName: this.getTicketName,
                                payNum: this.userList.length,
                                certificateType: this.infoType ? "0":"1",
                                visitorVOList,
                            }
                        ],
                        type,
                        visitStartTime: this.getStartTimeStr,
                        visitEndTime: this.getStartEndStr,
                        //  销售渠道（0：窗口，1：官网，2：微信）	
                        sellMethod: '2',
                        remark: this.contactsInfo.remark,
                        //临展Id 如果是临展的时候需要带上
                        exhibitionId: this.getTicketType === 'exhibition' ? this.getTicketId : '',
                    }

                    var flag = false;
                    //  检验 用户信息手动录入相同的游客
                    for (let index = 0, len = this.userList.length - 1; index < len; index++) {
                        const out = this.userList[index];
                        if(flag){
                            return ;
                        }
                        for (let index2 = index + 1, len2 = this.userList.length; index2 < len2; index2++) {
                            const inner = this.userList[index2];
                            if(out.id === inner.id){
                                flag = true;
                                inner.idNumberErrorTxt = '游客信息重复';
                            }
                        }
                    }

                    if(flag){
                        return ;
                    }
                    this.$http.post(commitOrderTicketUrl,data)
                        .then(res=>{
                            const {
                                data: {
                                    orderNo = '',
                                },
                                msg = ''
                            } = res;
                            if(orderNo){
                                this.$router.push({ name: 'ticketingInfoSuccess', query: {'id':orderNo }})
                                // this.$router.push({name:'ticketAppointmentSuccess', query: {'id':orderNo }});
                            }else{
                                this.$dialog({ 
                                    title: '预约失败',
                                    message: msg
                                });
                            }
                        },err=>{
                            const {
                                msg: message
                            } = err;
                            this.$toast.clear();
                            this.$dialog({ 
                                title: '预约失败',
                                message 
                            });
                        })

                }

            },
            onInput(item){
                item.idNumberErrorTxt = ''
            },
            checkName(v){
                return /^[\u4e00-\u9fa5_a-zA-Z]{2,10}$/.test(v)
                // return v === ""? false : true;
            },
            checkPhone(v){
                return this.phonePattern.test(v)
                // return new Promise(resolve => {
                //     this.$toast.loading({
                //         forbidClick: true,
                //         message: '验证中...'
                //     });
                //     setTimeout(() => {
                //         this.$toast.clear();
                //         resolve(this.phonePattern.test(v));
                //     }, 700);
                // });
            },
            checkId(v){
                if(this.infoType){
                    return this.idPattern.test(v);
                }else{
                    this.checkName(v);
                }
            },
        },
        computed: {
            getUserId(){
                return this.$store.state.userInfo.userId || ''
            },
            getOpenId(){
                return this.$store.state.userInfo.openId || ''
            },
            // getUserNumber(){
            //     return this.userArray.length;
            // },
            //  门票id
            getTicketId(){
                var {
                    ticketId = ''
                } = this.$store.state.tempTransmitParams;
                return ticketId;
            },
            //  区分是门票还是临展
            getTicketType(){
                var {
                    type = ''
                } = this.$store.state.tempTransmitParams;
                return type;
            },
            // // 是否免费门票
            // getIsCharge(){
            //     var {
            //         charge = 0
            //     } = this.$store.state.tempTransmitParams;
            //     return charge === 0 ? true : false;
            // },
            //  门票价格
            getTicketPrice(){
                var {
                    ticketPrice = 0,
                    charge = 0,
                } = this.$store.state.tempTransmitParams;
                return charge === 0 ? 0 : ticketPrice;
            },
            //  门票名称
            getTicketName(){
                var {
                    name = ''
                } = this.$store.state.tempTransmitParams;
                return name;
            },
            //  获取购票团体类型
            getTickerModeType(){
                var {
                    tickerModel = 1
                } = this.$store.state.tempTransmitParams;
                return tickerModel;
            },
            //  游玩时间
            getTimeStr(){
                var {
                    year = '',
                    time = '',
                } = this.$store.state.tempTransmitParams;
                year = year.replace('-','年')
                year = year.replace('-','月')
                year += '日';
                this.getStartTimeStr
                return year + " " + time;
            },
            getStartTimeStr(){
                var {
                    year = '',
                    time = ''
                } = this.$store.state.tempTransmitParams;
                return year + ' ' + time.split(' - ')[0] + ':00';
            },
            getStartEndStr(){
                var {
                    year = '',
                    time = ''
                } = this.$store.state.tempTransmitParams;
                return year + ' ' + time.split(' - ')[1] + ':00';
            },
        },
        components:{
            [Field.name]: Field,
            [Form.name]: Form,
            [Button.name]: Button,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";
    .container{
        height: ~"calc(100% - 50px)" !important;
        font-size: 14px;
        // *{
        //     transition: all .3s ease;
        // }
        .header{
            position: relative;
            padding: 0 17px;
            background-color: #ffffff;
            height: 56px;
            color: #9C9C9C;
            .header-item{
                white-space: nowrap;
                width: auto;
                position: relative;
                // width: 100px;
                text-align: center;
            }
            .item-line{
                width: 20%;
                // margin: 0 10px;
                border-bottom: 1PX dotted #9C9C9C;
            }
            .left{
                width: ~'calc(20% - 25px)';
                margin-right: 25px;
            }
            .header-item-active{
                // margin: 0 10px;
                margin-left: -25px;
                &::before{
                    background-color: #4282FF;
                    content: '';
                    border-radius: 2px;
                    height: 5px;
                    width: 65px;
                    position: absolute;
                    bottom: -10px;
                    left: 50%;
                    transform: translateX(-50%);
                }
            }
        }
        .body{
            @paddingSize:7px;
            padding:@paddingSize; 
            .p-b-b{
                margin-bottom:@paddingSize;
            }
            .white-box{
                background-color: #ffffff;
                padding-left: 12px;
                padding-right: 12px;
                border-radius: 5px;
            }
            .body-container{
                .body-header{
                    .white-box();
                    .ticket-info{
                        white-space: nowrap;
                        .icon-size{
                            &::before{
                                font-size: 15px;
                            }
                        }
                        span{
                            margin-left: 10px;
                        }
                        .name{
                            max-width: 150px;
                            display: inline-block;
                            vertical-align: bottom;
                        }
                    }
                    .ticket-use-time{
                        justify-content: flex-start;
                        .icon-size{
                            &::before{
                                font-size: 20px;
                            }
                        }
                        span{
                            color: #787D88;
                            margin-left: 10px;
                        }
                    }
                    .item-row{
                        &:last-child{
                            border: 0;
                        }
                    }
                }
                .item-row{
                    box-sizing: border-box;
                    height: 50px;
                    // padding-left: 12px;
                    // padding-right: 12px;
                    border-bottom: .5px solid #CBCBCB;
                }
                .contacts-box{
                    border-radius: 5px;
                    padding: 0 12px;
                    background-color: #ffffff;
                    overflow: hidden;
                    .item-row:last-child{
                        border: 0;
                    }
                }
                .contacts-box-head{
                    height: 50px;
                    padding: 0 12px; 
                }
                .tourist-btn{
                    background-color: #ffffff;
                    .contacts-box-head();
                    border-radius: 5px;
                    overflow: hidden;
                    position: relative;
                    .item-row{
                        border: 0;
                    }
                    .control-btn{
                        top: 50%;
                        position: absolute;
                        right: 0;
                        padding-right: 12px;
                        z-index: 2;
                        transform: translate(0px, -50%);
                        .number-box{
                            margin: 0 6px;
                            width: 24px;
                            height: 24px;
                            font-size: 14px;
                            display: inline-flex;
                            justify-content: center;
                            align-items: center;
                            border:1px solid rgba(212,212,212,1);
                        }
                        .icon-size{
                            &::before{
                                font-size: 22px;
                            }
                        }
                    }
                    .type-box{
                        width: 208px;
                        justify-content: flex-start;
                        .btn-box{
                            .quan-size{
                                transition: all .3s ease;
                                margin-right: 5px;
                            }
                            &:first-child{
                                margin-right: 70px;
                            }
                        }
                    }
                }
            }
            .user-row{
                position: relative;
                margin-bottom: 14px;
                margin-top: 14px;
                padding: 0 12px;
                border-radius: 5px;
                overflow: hidden;
                background-color: #ffffff;
                &:last-child{
                    margin-bottom: 7px;
                }
                // .item-row:last-child{
                //     border: 0;
                // }
                .item-row{
                    // &:last-child{
                    //     border: 0;
                    // }
                    &:nth-child(2),
                    &:last-child{
                        border: 0;
                    }
                }
                .icon-size{
                    color: #787D88;
                    position: absolute;
                    right: 7px;
                    top: 13px;
                    z-index: 2;
                    // top: 50%;
                    // transform: translateY(-50%);
                    &::before{
                        font-size: 20px;
                    }
                }
            }
        }
        .foot{
            box-sizing: border-box;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #ffffff;
            height:50px;
            .left{
                padding: 12px;
                font-size: 18px;
            }
            .right{
                border-radius: 0;
                box-sizing: border-box;
                font-size: 15px;
                width:110px;
                color: #ffffff;
                height: 50px;
            }
        }
    }
</style>